import { Component, Input } from '@angular/core';
import { BreadCrumb } from '../../models/components';
import { capitalize } from '../../services/ui.service';

@Component({
  selector: 'app-breadcrumbs',
  templateUrl: './breadcrumbs.component.html',
  styleUrls: ['./breadcrumbs.component.scss']
})
export class BreadcrumbsComponent {

  @Input() breadcrumbs: BreadCrumb[];

  constructor() {
    this.breadcrumbs = [];
  }

  navTo(breadcrumb: BreadCrumb) {
    if (typeof breadcrumb.navTo === 'function') breadcrumb.navTo();
  }

}
